var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[(_vm.visible)?_c('div',{staticClass:"ml-auto"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }